import { ApiEndpointClient } from './resource-client';
const VALUATION_API_PREFIX = 'valuation-api/v1';
export class PlausibilityClient extends ApiEndpointClient {
    http;
    constructor(http) {
        super(http, VALUATION_API_PREFIX);
        this.http = http;
    }
    getPlausibility = async ({ valuationId, customerId }) => {
        return this.get(`/valuations/${valuationId}/plausibility`, {
            query: customerId ? { customer_uuid: customerId } : undefined,
        });
    };
    patchPlausibility = async ({ valuationId, customerId, operations, }) => {
        await this.patch(`/valuations/${valuationId}/plausibility`, {
            query: customerId ? { customer_uuid: customerId } : undefined,
            json: operations,
            response: 'raw',
        });
    };
}
export function isPdfAnnotation(annotation) {
    return annotation.annotation_type === 'pdf';
}
export function isDeviationAnalysisAnnotation(annotation) {
    return annotation.annotation_type === 'deviation';
}
export function isPlausibilityVisibleToAppraisers(plausibility) {
    return !!(plausibility?.is_handed_over || plausibility?.is_approved || plausibility?.is_internally_approved);
}
